export const appName = 'Casal Innovations'
export const appTagline = 'Helping businesses create abundance'
export const bookingInbox = 'hello@casalinnovations.com'
/** Path after cal.com/ — profile or event type, e.g. casalinnovations or user/30min */
export const calComLink = 'casalinnovations'

type Company = {
	legalName: string
	address: {
		street: string
		postalCode: string
		city: string
		country: string
	}
	/** NIPC / NIF de pessoa coletiva */
	nif: string
	shareCapital: string
	email: string
}

/**
 * Registered company details for the footer and legal pages.
 * Source of truth: ~/Documents/productivity/company (certidão / AT / seguros).
 * Contact is email or the book-a-call flow only — no phone on the site.
 */
export const company: Company = {
	legalName: 'Casal Innovations, Lda',
	address: {
		street: 'Rua Padre Américo, n.º 10, 3.º Direito',
		postalCode: '2675-288',
		city: 'Odivelas',
		country: 'Portugal',
	},
	nif: '518617572',
	shareCapital: '€1.000,00',
	email: bookingInbox,
}

/** Display form of the NIPC (Portuguese grouping). */
export function formatNif(nif: string) {
	return nif.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
}
